import styled from 'styled-components';

export const Container = styled.div``;

export const OptionsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 14px 0 40px 0;

  div {
    margin: 0;
    label {
      font-weight: normal !important;
    }
  }
`;
